import _isObject from 'lodash/isObject';
import { addMinutes, differenceInMilliseconds, subMinutes, parseISO } from 'date-fns';
import { STRINGS } from 'config';

export const convertMinutesToMilliseconds = minutes => 1000 * 60 * minutes;

export const getSessionExpiryTime = () => {
  return addMinutes(new Date(), STRINGS.SESSION_TIMEOUT.IN_MINUTES);
};

export const calculateSessionExpiryTime = sessionExpiryTime => {
  const expiryDateTime = _isObject(sessionExpiryTime) ? sessionExpiryTime : parseISO(sessionExpiryTime);
  const millisecondsToSessionExpiry = differenceInMilliseconds(expiryDateTime, new Date());
  const expiryWarningDateTime = subMinutes(expiryDateTime, (STRINGS.SESSION_TIMEOUT.IN_MINUTES / 2));
  const millisecondsToSessionWarning = differenceInMilliseconds(expiryWarningDateTime, new Date());
  return { millisecondsToSessionWarning, millisecondsToSessionExpiry };
};
